module.exports = __webpack_public_path__ + "static/media/points.a0fb43c6.svg";